import { setLocalStorageItem, getLocalStorageItem, Key } from 'src/utils/localStorage';
import { error } from 'loglevel';

export const COMMUNITIES_DEFAULT_HIDE_IMAGE = [646, 195, 47, 803, 708, 949, 631, 796];

export const getDisplayImagePreference = (communityId: number) => {
  try {
    let preferences = JSON.parse(getLocalStorageItem(Key.showImagesPreference) || '{}');
    if (typeof preferences === 'string') preferences = JSON.parse(preferences);
    const preference = preferences['communityId_' + communityId];
    return typeof preference !== 'undefined' ? preference : !COMMUNITIES_DEFAULT_HIDE_IMAGE.includes(communityId);
  } catch (e) {
    error(e);
  }
};

export const setDisplayImagePreference = (communityId: number, preference: boolean) => {
  try {
    let preferences = JSON.parse(getLocalStorageItem(Key.showImagesPreference) || '{}');
    if (typeof preferences === 'string') preferences = JSON.parse(preferences);
    preferences['communityId_' + communityId] = preference;
    setLocalStorageItem(Key.showImagesPreference, JSON.stringify(preferences));
  } catch (e) {
    error(e);
  }
};
